import React from 'react'
import { Link } from 'gatsby'

import * as styles from './styles.module.scss'

const PostPreview = ({ slug, title, publishDate, imageSrc }) => (
  <Link to={slug} className={styles.Post}>
    <div className={styles.Image}>
      <img src={`${imageSrc}?w=500&q=50`} alt="" />
    </div>
    <div className={styles.Content}>
      <h3>{title}</h3>
      <small>{publishDate}</small>
    </div>
  </Link>
)

export default PostPreview
